<template>
  <Modal title="处理投诉" v-model="visibleThis">
    <Form
      ref="editSalaryForm"
      class="form"
      :label-width="80"
      :complaintRow="complaintRowThis"
      :model="complaintRowThis"
      :rules="ruleSalary"
    >
      <Row>
        <Col :span="22">
          <Row>
            <Form-item label="投诉理由" prop="remark">
              <Select v-model="complaintRowThis.remark"  @on-change="changeRemark" disabled>
                <Option v-for="(item,index) in $constant.tchComplaintRemark"
                        :value="item.text" :key="index">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="学生赠送课时" prop="stdNum">
              <Input v-model="complaintRowThis.stdNum"></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="老师课耗" prop="subSalary">
              <Select v-model="complaintRowThis.subSalary">
                <Option v-for="item in this.subSalaryEnum" :value="item.code" :key="item.code">{{ item.text }}</Option>
              </Select>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="老师额外扣除($)" prop="tchNum">
              <Input v-model="complaintRowThis.tchNum"></Input>
            </Form-item>
          </Row>
        </Col>
        <Col :span="22">
          <Row>
            <Form-item label="处理意见" prop="doRemark" >
              <Input v-model="complaintRowThis.doRemark" placeholder="请输入处理意见:警告"></Input>
            </Form-item>
          </Row>
        </Col>
      </Row>
    </Form>
    <div slot="footer">
      <Button type="text" size="large" @click="visibleThis = false">取消</Button>
      <Button
        type="primary"
        size="large"
        :loading="loadingEditSalary"
        @click="editSalary"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>
<script>
export default {
  name: 'ModifyComplaintModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    complaintRow: {
      type: Object,
      default: {}
    },
    successCallback: {
      type: Function
    }
  },
  data () {
    let $constant = this.$constant
    return {
      visibleThis: this.visible,
      loadingEditSalary: false,
      complaintRowThis: {},
      ruleSalary: {},
      complaintRemarkList: $constant.tchComplaintRemark,
      subSalaryEnum: [{code: 0, text: '正常计算'}, {code: 1, text: '不计算'}]
    }
  },
  methods: {
    editSalary () {
      let self = this
      self.loadingEditSalary = true
      self.$refs.editSalaryForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingEditSalary = false
          return
        }
        self.$http.post('/tchList/complaint/update', this.complaintRowThis).then(function (res) {
          self.$Message.success('成功!')
          self.visibleThis = false
          self.loadingEditSalary = false
          self.successCallback()
        }).catch(function (e) {
          self.loadingEditSalary = false
        })
      })
    },
    changeRemark (val) {
      this.complaintRemarkList.forEach(item => {
        if (item.text === val.remark) {
          this.complaintRowThis.stdNum = item.stdNum
          this.complaintRowThis.tchNum = item.tchNum
          this.complaintRowThis.subSalary = item.subSalary
        }
      })
    }
  },
  watch: {
    visible (val) {
      this.visibleThis = val
    },
    visibleThis (val) {
      if (!val) {
        this.complaintRowThis = {}
        this.$emit('on-close', val)
      }
    },
    complaintRow (val) {
      this.complaintRowThis = val
      if (this.complaintRowThis.status === 0) {
        this.complaintRemarkList.forEach(item => {
          if (item.text === val.remark) {
            this.complaintRowThis.stdNum = item.stdNum
            this.complaintRowThis.tchNum = item.tchNum
            this.complaintRowThis.subSalary = item.subSalary
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ModifyComplaintModal.vue?2a484dda